import { useQuery } from '@tanstack/react-query';
import { api } from './api.ts';

export interface OfficeStatus {
  open: boolean;
  /** "Mon–Fri, 08:00–17:00" */
  hours: string;
  nextOpening: string | null;
  holidayToday: string | null;
  personalSlot: string;
  /** During the lunch break: when it ends. */
  breakUntil: string | null;
  /** IT on leave or off today, and who's covering. */
  cover: { away: string; until: string; reason: 'leave' | 'off'; cover: string | null }[];
  /** IT out of the premises on official duty, until when. */
  out: { name: string; until: string }[];
}

/** Office hours and who's covering: for the report form and the banner. */
export function useOfficeStatus() {
  return useQuery({
    queryKey: ['office-status'],
    queryFn: () => api.get<OfficeStatus>('/api/office/status'),
    staleTime: 5 * 60_000,
  });
}
